import { Container } from 'react-bootstrap'
import logoMobile from "./images/galet-thecamp-white.svg"

export default function TopNav() {
    return (
        <div className="mobile-top-nav">
            <div className="top-nav-content">
                <Container fluid className="px-0">
                    <div className="header-container top-nav mx-0">
                        <div className="logo-mobile ">
                            <img src={logoMobile} alt="logo thecamp"/>
                        </div>
                        <div className="top-nav-title">Le plan</div>
                    </div>
                </Container>
            </div>
        </div>
    )
}
